import { Divider } from 'component-library';
import { useTranslation } from 'react-i18next';

import { IndicatorName } from '@/api/rest/resources/types/fact';
import { GraphFact } from '@/components/Charts/types';
import { NCCard, NCCard2SectionLayout, NCCardComplianceFooter, NCCardHeader } from '@/components/NCCard/NCCard';
import { CanopyHeightExplainer } from '@/components/NCExplainers/CanopyHeightExplainer';
import { COMPLIANCE_LOGOS_CANOPY_HEIGHT } from '@/config/constants';
import { usePlotFacts } from '@/pages/shared/hooks/usePlotFact';
import { getFactFromFactArray } from '@/pages/shared/hooks/utils';
import { isNullish } from '@/utils/booleans';

import { PlotCardWrapper } from '../PlotCardWrapper';
import { CanopyHeightGraphTile } from './GraphTile';
import { CanopyHeightCardStatsTile } from './StatsTile';

export const CanopyHeight = () => {
  const { t } = useTranslation();

  return (
    <PlotCardWrapper name={t('shared.ncaDetail.details.forest.labels.canopyHeight')}>
      <CanopyHeightPlotCard />
    </PlotCardWrapper>
  );
};

const CanopyHeightPlotCard = () => {
  const { t } = useTranslation();

  const factNames = {
    graph: IndicatorName.canopy_height_graph,
    latestAnalysis: IndicatorName.canopy_height,
  };

  const facts = usePlotFacts(Object.values(factNames));

  const graphData = getFactFromFactArray<GraphFact[]>(facts, factNames.graph)?.value;
  const latestFact = getFactFromFactArray<number>(facts, factNames.latestAnalysis);

  const hasChartData = !isNullish(graphData);
  const hasStatsData = !isNullish(latestFact?.value);

  if (!hasChartData && !hasStatsData) {
    return null;
  }

  return (
    <NCCard explainer={<CanopyHeightExplainer />}>
      <NCCardHeader
        title={t('shared.ncaDetail.details.forest.labels.canopyHeight')}
        className='lg:grid-cols-[1fr_1fr]'
      />
      <NCCard2SectionLayout>
        <CanopyHeightGraphTile graphData={graphData} />
        <CanopyHeightCardStatsTile latestAnalysisFact={latestFact} />
      </NCCard2SectionLayout>
      <Divider />
      <NCCardComplianceFooter logos={COMPLIANCE_LOGOS_CANOPY_HEIGHT} />
    </NCCard>
  );
};
